import { EditOutlined } from '@ant-design/icons';
import { Button, Form, Input, Space } from 'antd';
import { useUpdateTicketSheethNo } from 'features/transaction_list/use-cases/update-ticket-sheet';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';


// type booth_no_list = {
//     booth_no: number;
//     booth_price: number;
//     booth_registration_id: number;
//     event_id: number;
//     id: number;
// }
// type boothData = {
//     booth_nos: string;
//     booth_registration_id: number;
//     email: string;
//     event_id: number;
//     booth_no_list: booth_no_list[]
// }

interface props {
    onClose: () => void,
    isOpen: boolean,
    boothData: any
}

export const EditTicketSeatModal = ({ onClose, isOpen, boothData }: props) => {

    const formName = 'edit-ticket-seat-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<any>();
    const { t } = useTranslation();

    const { isLoading, mutate } = useUpdateTicketSheethNo();
    const [editBoothId, setEditBoothId] = useState<number | null>(null)


    const seatData = boothData?.SeatNumbers ? boothData?.SeatNumbers.split(',').map(Number) : [];


    useEffect(() => {
        form.resetFields();
    }, [isOpen])

    const handleClose = () => {
        setEditBoothId(null);
        form.resetFields();
        onClose();
    };

    const handleUpdate = (formData: any) => {
        const payload = {
            LangId: 0,
            EventId: boothData?.EventId,      // Old booth id
            NewSeatNumber: formData.booth_name?.toString(),  // New booth name from form input
            OldSeatNumber: editBoothId?.toString(),
            CorelationId: boothData?.corelationId,
            BookingId: boothData?.BookingId
        };
        // console.log(payload, "payload")
        mutate(payload, {
            onSuccess: (data: any) => {
                if (data?.ResponseStatus === 1) {
                    handleClose();
                } else {
                    handleCancelClick();
                }

            },
        });
    };

    // const handleDeleteClick = (item: any) => {
    //     const payload = {
    //         Flag: "DELETE",
    //         booth_no_old: item.booth_no,  // Booth id to be deleted
    //         booth_registration_id: boothData.booth_registration_id,
    //         pageFlag: pageFlag
    //     };
    //     mutate(payload, { onSuccess: onClose });
    // };

    const handleEditClick = (booth: any) => {
        setEditBoothId(booth);  // Set the clicked booth for editing
        form.setFieldsValue({ booth_name: booth });  // Pre-fill the input with the selected booth's value
    };

    const handleCancelClick = () => {
        setEditBoothId(null);
        form.resetFields();
    };

    const handleSaveClick = () => {
        form.submit();  // Save the form data
    };


    return (

        <>
            <div className='popup'>
                <div className='modal_head'>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                    <h4>{"Edit Seat Number"}</h4>
                </div>
                <div className='modal_body'>
                    <Form
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        // initialValues={getInitialValues}
                        onFinish={handleUpdate}
                        // requiredMark={'optional'}
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                    >
                        <FormSectionsSeparator title={""}>
                            <div>
                                {seatData?.map((item: any, i: number) => (
                                    <div key={i} className='bt_wrap'>
                                        <Space className='booth_num'>
                                            {editBoothId === item ? (
                                                <Form.Item
                                                    label={"Edit Seat Number"}
                                                    name={"booth_name"}
                                                    rules={[{
                                                        required: true,
                                                        message: t('validateMessages.custom.nomsg'),
                                                    }]}
                                                >
                                                    <Input placeholder="Enter Seat Number" />
                                                </Form.Item>
                                            ) : (
                                                <span className='both_no'>{item}</span>
                                            )}

                                            {editBoothId === item ? (
                                                <div className='booth_btn'>
                                                    <Button onClick={handleSaveClick}
                                                        // disabled={editBoothId == item}
                                                        loading={isLoading} type='primary'>Save</Button>
                                                    <Button onClick={handleCancelClick} className='brder_btn'>Cancel</Button>
                                                </div>
                                            ) : (
                                                <div className='booth_btn'>
                                                    <Button onClick={() => handleEditClick(item)}><EditOutlined /></Button>

                                                </div>
                                            )}
                                        </Space>
                                    </div>
                                ))}
                            </div>
                        </FormSectionsSeparator>

                    </Form>

                </div>
            </div>
        </>
    );
};
